import { render, staticRenderFns } from "./A_fake.vue?vue&type=template&id=5b2def1b&scoped=true&"
import script from "./A_fake.vue?vue&type=script&lang=js&"
export * from "./A_fake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2def1b",
  null
  
)

export default component.exports